// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Va","field":"i_Vb","icon":"i_Vc","label":"i_Vd"};